import { Typography } from '@mui/material';

import { getTheme } from '@sh4res/bo-common/theme';
import { useBackendVersion } from '@sh4res/bo-common/utils/backend_version_store';

/** Backend version and git SHA, shown in the menu below the user UTC time */
export function AppVersion() {
  const version = useBackendVersion();
  if (version === undefined) {
    return null;
  }

  // the AXA menu has a white background, all others a dark one
  const rgb = getTheme() === 'axa' ? '0, 0, 0' : '255, 255, 255';

  return (
    <Typography
      data-testid="MenuBuilder_AppVersion"
      sx={{
        color: `rgba(${rgb}, 0.4) !important`,
        fontWeight: 400,
        fontSize: '10px',
        lineHeight: '14px',
        margin: 0,
      }}>
      v{version.version} <span style={{ color: `rgba(${rgb}, 0.2)` }}>({version.sha})</span>
    </Typography>
  );
}
